export default {
    validate(value) {
        if (value === null)
            return true

        const chars = "A-ZÁÉÍÓÚÂÊÎÔÛÃÕÄËÏÖÜÇ'"

        return !!value.trim().match(new RegExp(`^[${chars}]{3,}\\s([${chars}]{1,}\\s?)*[${chars}]{3,}$`))
    },
    message: () => 'Digite um Nome e Sobrenome válidos',
}